import { Moment } from 'moment';

export enum VehiclesWithoutMovementOrderByColumn {
  customer = 'customer',
  licensePlate = 'license_plate',
  brand = 'brand',
  model = 'model',
  lastEntryDate = 'last_entry_date',
}

export enum VehiclesWithoutMovementWorkOrderTypeFilter {
  courtesy = 'COURTESY',
  warranty = 'WARRANTY',
  workOrder = 'WORK_ORDER',
  totalLoss = 'TOTAL_LOSS',
  return = 'RETURN',
  revision = 'REVISION',
}

export enum VehiclesWithoutMovementWorkOrderSituationsFilter {
  closed = 'Closed',
  open = 'Open',
  authorized = 'Authorized',
}

export interface VehiclesWithoutMovementRequest {
  companiesIds?: number[];
  startDate: string;
  endDate: string;
  format: string;
  orderByColumn?: VehiclesWithoutMovementOrderByColumn;
  showInactiveCustomers?: boolean;
  workOrderSituationsFilter?: VehiclesWithoutMovementWorkOrderSituationsFilter[];
  workOrderTypeFilter?: VehiclesWithoutMovementWorkOrderTypeFilter[];
}

export interface ReportVehicleWithoutMovementFormValues {
  companiesIds?: number[];
  showInactiveCustomers?: boolean;
  orderByColumn?: VehiclesWithoutMovementOrderByColumn;
  workOrderSituationsFilter?: VehiclesWithoutMovementWorkOrderSituationsFilter[];
  workOrderTypesFilter?: VehiclesWithoutMovementWorkOrderTypeFilter[];
  initialDate: Moment;
  finalDate: Moment;
}
